

function NotificationTile(aTitle, aBody, aImageUri, aNavigateUri, aNavigateTitle, aIsDismissable) {

    this.Title = aTitle;
    this.Body = aBody;
    this.ImageUri = aImageUri;
    this.NavigateUri = aNavigateUri;
    this.NavigateTitle = aNavigateTitle;
    this.IsDismissable = aIsDismissable;
    this.Id = 'u' + this.Title.split(' ').join('') + 'NotificationTile';

    this.RenderContents = function (aBaseElement) {
        var lBaseDiv = $('<div/>', {
            'id': this.Id,
            'class': 'NotificationTile ' + this.Title.split(' ').join('') + 'Tile'
        });

        var lTable = $('<table/>', {});
        var lTableRow1 = $('<tr/>', {});
        var lTableRow2 = $('<tr/>', {});
        var lTableRow3 = $('<tr/>', {});

        var lTableRow1Cell1 = $('<td/>', {
            'class': 'ImageCell',
            'rowspan': 3
        });

        var lTableRow1Cell2 = $('<td/>', {
            'class': 'TitleCell'
        });

        var lTableRow1Cell3 = $('<td/>', {
            'class': 'DismissCell',
            'rowspan': 3
        });

        var lTableRow2Cell2 = $('<td/>', {
            'class': 'BodyCell'
        });

        var lTableRow3Cell2 = $('<td/>', {
            'class': 'LinkCell'
        });

        if (this.ImageUri != null && this.ImageUri != '') {
            $('<img/>', {
                'src': this.ImageUri,
                'alt': this.Title,
                'title': this.Title
            }).appendTo(lTableRow1Cell1);
        }

        if (this.Title != null && this.Title != '') {
            $('<span/>', {
                'text': this.Title
            }).appendTo(lTableRow1Cell2);
        }

        if (this.IsDismissable) {
            $('<span/>', {
                'onclick': "CloseNavigation('" + this.Id + "')",
                'text': "x"
            }).appendTo(lTableRow1Cell3);
        }

        if (this.Body != null && this.Body != '') {
            $('<div/>', {
                'text': this.Body
            }).appendTo(lTableRow2Cell2);
        }

        if (this.NavigateUri != null && this.NavigateUri != '') {
            var lLinkTitle = 'click here';
            if (this.NavigateTitle != null && this.NavigateTitle != '') {
                lLinkTitle = this.NavigateTitle;
            }
            $('<a/>', {
                href: this.NavigateUri,
                'text': lLinkTitle
            }).appendTo(lTableRow3Cell2);
        }

        $(lTableRow1Cell1).appendTo(lTableRow1);
        $(lTableRow1Cell2).appendTo(lTableRow1);
        $(lTableRow1Cell3).appendTo(lTableRow1);
        $(lTableRow1).appendTo(lTable);
        $(lTableRow2Cell2).appendTo(lTableRow2);
        $(lTableRow2).appendTo(lTable);
        $(lTableRow3Cell2).appendTo(lTableRow3);
        $(lTableRow3).appendTo(lTable);
        $(lTable).appendTo(lBaseDiv);
        $(lBaseDiv).appendTo(aBaseElement);
    }

}

///////////////////////////////////////////////////////////////////////////////////////////////////////
// SumoListView
///////////////////////////////////////////////////////////////////////////////////////////////////////


// aGridId = component id. ex: <table id="uContactGrid" ...
// aBaseElementId = parent container id
// aColumns = array of column structure. if you pass only one, enclose it in [] anyway. ex: [{Id:"SerialNumber", Title:"Serial #", DataField:"SerialNumber", Formatter:DateFormatFunction}]
// aDataSource = the dataset that will be assigned to the grid - it's the list of stuff we want to display
// aIsSelectable = does what it says it does - is the grid interactive or not

function SumoListView(aListViewId, aBaseElementId, aColumns, aDataSource, aIsSelectable, aSettings) {
    this.Id = aListViewId;
    this.BaseElementId = aBaseElementId;
    this.Columns = aColumns;
    this.DataSource = aDataSource;
    this.IsSelectable = aIsSelectable;
    this.Settings = aSettings;

    var lTableBody,
        mFilterVisible = false,
        mFilterContentDiv,
        mExpression = null,
        mFilteredList = aDataSource,
        mBaseElement = null,
        mIdentifier = null,
        mDataFilter = null,
        mFilterExpression = null,
        mFilterOptions = [];

    this.RenderContents = function (aIsNew, aDoFilter) {
        var lListViewComponent = $('#' + this.Id);
        if (lListViewComponent.length === 0 || (typeof aIsNew === 'undefined' || aIsNew === null || aIsNew)) {
            RenderNewListView(this.Id, this.BaseElementId, this.Columns, mFilteredList, this.IsSelectable, this);
        } else {
            // it already exists, update the ListView
            UpdateExistingListView(this, aDoFilter);
        }
    }

    function ToggleFilterVisibility(aListView) {
        mFilterVisible = !mFilterVisible;
        if (mFilterVisible) {
            mFilterContentDiv.show("fast");
        } else {
            mFilterContentDiv.hide("fast");
        }
    }

    function ToggleColumnVisibility(aListView, aSender) {
        var lColumnId = aSender.target.getAttribute('ColumnId');
        lColumn = aListView.Columns[lColumnId];
        lColumn.IsVisible = !lColumn.IsVisible;
        var lColumnItems = $('.' + aListView.Id + lColumn.Id);

        if (lColumn.IsVisible) {
            lColumnItems.show();
            mFilterOptions[lColumnId].addClass('SumoListViewFilterVisible').removeClass('SumoListViewFilterHidden');
        } else {
            lColumnItems.hide();
            mFilterOptions[lColumnId].addClass('SumoListViewFilterHidden').removeClass('SumoListViewFilterVisible');
        }
    }

    function GetDataItemIdentifier(aDataItem, aKey) {
        var lReturn = null;
        if (mIdentifier !== null) {
            lReturn = aDataItem[mIdentifier];
        } else {
            lReturn = aDataItem.Id || aKey;
        }

        return lReturn;
    }

    function GenerateNewListViewRow(aDataItem, aIdentifier, aColumns) {
        var lTableRow;
        if (typeof aDataItem !== 'undefined' && aDataItem !== null) {
            lTableRow = $('<tr/>', {
                'id': aListViewId + 'Row' + aIdentifier,
                'class': aListViewId + 'DataRow Clickable'
            });
            for (i = 0; i < aColumns.length; i++) {
                var lColumn = aColumns[i],
            lCellText = aDataItem[lColumn.DataField];
                if (typeof lColumn.Formatter !== 'undefined' && lColumn.Formatter !== null) {
                    lCellText = lColumn.Formatter(lCellText, lColumn.Id);
                }
                // note to Mark: the following line of code is in a specific order to help jquery - leave it the hell alone!
                // 'id': aListViewId + lColumn.Id + 'Cell' + lIdentifier,
                var lCell = $('<td/>', {
                    'id': aListViewId + lColumn.Id + 'Cell' + aIdentifier,
                    'class': aListViewId + lColumn.Id + 'Cell' + ' ' + aListViewId + lColumn.Id,
                    'html': lCellText
                });
                if (typeof lColumn.Hidden !== 'undefined' && lColumn.Hidden) {
                    lCell.hide();
                }
                $(lCell).appendTo(lTableRow);
            }
        }
        return lTableRow;
    }

    function UpdateExistingListView(aListView, aDoFilter) {
        //aListView.Filter(null);
        if (isNullOrUndefined(aDoFilter) || aDoFilter) {
            InternalFilter(aListView, mExpression);
        }
        if (typeof mFilteredList !== 'undefined' && mFilteredList != null) {
            var lKey;
            $('.' + aListView.Id + 'DataRow').attr('ToRemove', 'true');
            for (lKey in mFilteredList) {
                if (mFilteredList.hasOwnProperty(lKey)) {
                    var lDataItem = mFilteredList[lKey];
                    if (lDataItem != null) {
                        var lIdentifier = GetDataItemIdentifier(lDataItem, lKey),
                        lListViewItem = $('#' + aListView.Id + 'Row' + lIdentifier);
                        if (lListViewItem.length === 1) {
                            lListViewItem.removeAttr('ToRemove');
                            if (typeof lDataItem !== 'undefined' && lDataItem !== null) {
                                for (i = 0; i < aListView.Columns.length; i++) {
                                    var lColumn = aListView.Columns[i],
                                    lCellText = lDataItem[lColumn.DataField];
                                    if (typeof lColumn.Formatter !== 'undefined' && lColumn.Formatter !== null) {
                                        lCellText = lColumn.Formatter(lCellText);
                                    }
                                    $('#' + aListView.Id + lColumn.Id + 'Cell' + lIdentifier).html(lCellText);
                                }
                            }
                        } else {
                            $(GenerateNewListViewRow(lDataItem, lIdentifier, aListView.Columns)).appendTo(lTableBody);
                        }
                    } else {
                        $('#' + aListView.Id + 'Row' + lKey).remove();
                    }
                }
            }
        }
        $('[ToRemove]').remove();
    }

    function RenderNewListView(aListViewId, aBaseElementId, aColumns, aDataSource, aIsSelectable, aListView) {
        var lTitleText = '',
            lIsHeaderVisible = false,
            lFilterDiv = $('<div/>', {});
        mFilterContentDiv = $('<div/>', {});
        if (typeof aListView.Settings !== 'undefined' && aListView.Settings !== null) {
            if (aListView.Settings.hasOwnProperty('Title')) {
                lTitleText = aSettings.Title;
                lIsHeaderVisible = true;
            }
            if (aListView.Settings.hasOwnProperty('DataFilter')) {
                mDataFilter = aListView.Settings.DataFilter;
            }
            if (aListView.Settings.hasOwnProperty('Identifier')) {
                mIdentifier = aListView.Settings.Identifier;
            }
            if (aListView.Settings.hasOwnProperty('ColumnsFilterable') && aListView.Settings.ColumnsFilterable) {
                lIsHeaderVisible = true;
                lFilterDiv = $('<div/>', {
                    'class': 'SumoListViewColumnFilter'
                });
                var lFilterDivText = $('<div/>', {
                    'html': 'Columns',
                    'class': 'SumoListViewColumnFilterText Clickable'
                })
                .click(function () { ToggleFilterVisibility(this); });

                lFilterDivText.appendTo(lFilterDiv);
                mFilterContentDiv = $('<div/>', {
                    'class': 'SumoListViewColumnFilterContent',
                    'style': 'display: none;'
                });

                if (typeof aColumns !== 'undefined' && aColumns != null && aColumns.length > 0) {
                    // write the header
                    for (i = 0; i < aColumns.length; i++) {
                        var lColumn = aColumns[i],
                            lColumnClass = 'SumoListViewFilterHidden';
                        if (typeof lColumn['IsVisible'] === 'undefined' || lColumn['IsVisible'] === null) {
                            lColumn['IsVisible'] = true;
                        }
                        if (lColumn['IsVisible']) {
                            lColumnClass = 'SumoListViewFilterVisible'
                        }
                        var lColumnSelect = $('<div/>', {
                            'html': lColumn.Title,
                            'class': 'Clickable ' + lColumnClass,
                            'ColumnId': i
                        });
                        lColumnSelect.click(function (aSender) {
                            ToggleColumnVisibility(aListView, aSender)
                        });
                        lColumnSelect.appendTo(mFilterContentDiv);
                        mFilterOptions[i] = lColumnSelect;
                    }
                }
            }
        }

        if (typeof aBaseElementId === 'string') {
            mBaseElement = $('#' + aBaseElementId);
        }
        else {
            mBaseElement = aBaseElementId;
        }

        var i,
            lBaseDiv = $('<div/>', {
                'id': aListViewId + 'Component'
            }),
            lHeaderDiv = $('<div/>', {
                'class': 'SumoListViewHeading'
            }),
            lTitleSpan = $('<span/>', {
                'html': lTitleText,
                'class': 'SumoListViewTitle'
            }),
            lTable = $('<table/>', {
                'id': aListViewId,
                'class': 'SumoListView',
                'cellpadding': '0px',
                'cellspacing': '0px'
            }),
            lTableHead = $('<thead/>', {}),
            lTableHeadRow1 = $('<tr/>', {
                'class': 'SumoListViewHeader'
            });
        if (mBaseElement.length === 1) {
            mBaseElement.html('');

            if (typeof aColumns !== 'undefined' && aColumns != null && aColumns.length > 0) {
                // write the header
                for (i = 0; i < aColumns.length; i++) {
                    var lColumn = aColumns[i],
                        lCell = $('<td/>', {
                            'html': lColumn.Title,
                            'class': aListViewId + lColumn.Id,
                            'id': aListViewId + lColumn.Id + 'Header'
                        });
                    if (typeof lColumn.Hidden !== 'undefined' && lColumn.Hidden) {
                        lCell.hide();
                    }
                    $(lCell).appendTo(lTableHeadRow1);
                }

                // vared above
                lTableBody = $('<tbody/>', {});

                if (typeof aDataSource !== 'undefined' && aDataSource != null) {
                    if (mDataFilter !== null) {
                        mFilteredList = query(aDataSource, mDataFilter);
                    } else {
                        mFilteredList = aDataSource;
                    }
                    for (var lKey in mFilteredList) {
                        var lDataItem = aDataSource[lKey],
                            lIdentifier = -1;
                        if (typeof lDataItem !== 'undefined' && lDataItem !== null) {
                            lIdentifier = GetDataItemIdentifier(lDataItem, lKey);
                            $(GenerateNewListViewRow(lDataItem, lIdentifier, aColumns)).appendTo(lTableBody);
                        }
                    }
                }
            }

            if (lIsHeaderVisible) {
                mFilterContentDiv.appendTo(lFilterDiv);
                lFilterDiv.appendTo(lHeaderDiv);
                lTitleSpan.appendTo(lHeaderDiv);
                lHeaderDiv.appendTo(lBaseDiv);
            }
            lTableHeadRow1.appendTo(lTableHead);
            lTableHead.appendTo(lTable);
            if (typeof aIsSelectable !== 'undefined' && aIsSelectable) {
                lTableBody.selectable({
                    stop: OnSelectChange
                });
            }
            lTableBody.appendTo(lTable);
            lTable.appendTo(lBaseDiv);
            lBaseDiv.appendTo(mBaseElement);
        }
    }

    // hypothetical
    this.SetIsSelectable = function (aIsSelectable) {
        if (aIsSelectable) {
            $(lTableBody).selectable({
                stop: OnSelectChange
            })
            .click(testxx);
        }
        else {
            $(lTableBody).selectable("disable");
        }
    }

    function OnSelectChange(event, ui) {
        window[aListViewId + '_OnSelectChange']();
    }

    this.HideColumn = function (aColumnId) {
        $('#' + this.Id + aColumnId + 'Header').hide();
        $('#' + this.Id + aColumnId + 'Cell').hide();
        var i = 0;
        for (i = 0; i < this.Columns.length; i++) {
            if (this.Columns[i].Id === aColumnId) {
                this.Columns[i].Hidden = true;
                break;
            }
        }
    }

    this.ShowColumn = function (aColumnId) {
        $('#' + this.Id + aColumnId + 'Header').show();
        $('#' + this.Id + aColumnId + 'Cell').show();
        var i = 0;
        for (i = 0; i < this.Columns.length; i++) {
            if (this.Columns[i].Id === aColumnId) {
                this.Columns[i].Hidden = false;
                break;
            }
        }
    }

    this.UnselectRowById = function (aItemId) {
        $('#' + this.Id + 'Row' + aItemId).removeClass("ui-selected");
    }

    this.SelectRowById = function (aItemId) {
        $('#' + this.Id + 'Row' + aItemId).addClass("ui-selected");
        var lRow = document.getElementById(this.Id + 'Row' + aItemId);
        if (!isNullOrUndefined(lRow)) {
            lRow.scrollIntoView(false);
        }
    }

    this.SelectRowByIndex = function (aIndex) {
        var lDataRow = $('.' + this.Id + 'DataRow')[aIndex]
        if (typeof lDataRow !== 'undefined' && lDataRow !== null) {
            $(lDataRow).addClass("ui-selected");
        }
    }

    this.RemoveRowById = function (aItemId) {
        $('#' + this.Id + 'Row' + aItemId).remove();
    }

    function InternalFilter(aListView, aExpression) {
        if (!isNullOrUndefined(aExpression)) {
            mFilteredList = query(aListView.DataSource, aExpression);
        } else {
            mFilteredList = aListView.DataSource;
        }
    }

    this.Filter = function (aExpression) {
        var lBuilder = new SumoPredicateBuilder();

        if (aExpression !== null) {
            lBuilder.AddConditional(aExpression, mLogicalOperatorEnum.And())
        }
        if (mDataFilter !== null) {
            lBuilder.AddConditional(mDataFilter, mLogicalOperatorEnum.And())
        }

        //        if (aExpression !== null && mDataFilter !== null) {
        //            mFilterExpression = lBuilder.RootExpression;
        //        } else if (aExpression !== null) {
        //            mFilterExpression = aExpression;
        //        } else {
        //            mFilterExpression = mDataFilter;
        //        }

        //mFilterExpression
        //mExpression = aExpression;
        InternalFilter(this, lBuilder.RootExpression);
        this.RenderContents(false, false);
    }

}

///////////////////////////////////////////////////////////////////////////////////////////////////////
// SumoListView2
///////////////////////////////////////////////////////////////////////////////////////////////////////


// aGridId = component id. ex: <table id="uContactGrid" ...
// aBaseElementId = parent container id
// aColumns = array of column structure. if you pass only one, enclose it in [] anyway. ex: [{Id:"SerialNumber", Title:"Serial #", DataField:"SerialNumber", Formatter:DateFormatFunction}]
// aDataSource = the dataset that will be assigned to the grid - it's the list of stuff we want to display
// aIsSelectable = does what it says it does - is the grid interactive or not

function SumoListView2(aListViewId, aBaseElementId, aColumns, aDataSource, aIsSelectable, aSettings) {
    this.Id = aListViewId;
    this.BaseElementId = aBaseElementId;
    this.Columns = aColumns;
    this.DataSource = aDataSource;
    this.IsSelectable = aIsSelectable;
    this.Settings = aSettings;

    var lTableBody,
        mFilterVisible = false,
        mFilterContentDiv,
        mExpression = null,
        mFilteredList = aDataSource,
        mBaseElement = null,
        mIdentifier = null,
        mDataFilter = null,
        mFilterExpression = null,
        mFilterOptions = [];

    this.RenderContents = function (aIsNew, aDoFilter) {
        var lListViewComponent = $('#' + this.Id);
        if (lListViewComponent.length === 0 || (typeof aIsNew === 'undefined' || aIsNew === null || aIsNew)) {
            RenderNewListView(this.Id, this.BaseElementId, this.Columns, mFilteredList, this.IsSelectable, this);
        } else {
            // it already exists, update the ListView
            UpdateExistingListView(this, aDoFilter);
        }
    }

    function ToggleFilterVisibility(aListView) {
        mFilterVisible = !mFilterVisible;
        if (mFilterVisible) {
            mFilterContentDiv.show("fast");
        } else {
            mFilterContentDiv.hide("fast");
        }
    }

    function ToggleColumnVisibility(aListView, aSender) {
        var lColumnId = aSender.target.getAttribute('ColumnId');
        lColumn = aListView.Columns[lColumnId];
        lColumn.IsVisible = !lColumn.IsVisible;
        var lColumnItems = $('.' + aListView.Id + lColumn.Id);

        if (lColumn.IsVisible) {
            lColumnItems.show();
            mFilterOptions[lColumnId].addClass('SumoListViewFilterVisible').removeClass('SumoListViewFilterHidden');
        } else {
            lColumnItems.hide();
            mFilterOptions[lColumnId].addClass('SumoListViewFilterHidden').removeClass('SumoListViewFilterVisible');
        }
    }

    function GetDataItemIdentifier(aDataItem, aKey) {
        var lReturn = null;
        if (mIdentifier !== null) {
            lReturn = aDataItem[mIdentifier];
        } else {
            lReturn = aDataItem.Id || aKey;
        }

        return lReturn;
    }

    function GenerateNewListViewRow(aDataItem, aIdentifier, aColumns) {
        var lHtmlCounter = -1,
            lTableRow = [];

        //lTableRow[++lHtmlCounter] = '';
        if (typeof aDataItem !== 'undefined' && aDataItem !== null) {
            lTableRow[++lHtmlCounter] = '<tr id="';
            lTableRow[++lHtmlCounter] = aListViewId + 'Row' + aIdentifier;
            lTableRow[++lHtmlCounter] = '" class="';
            lTableRow[++lHtmlCounter] = aListViewId + 'DataRow Clickable';
            lTableRow[++lHtmlCounter] = '">';

            for (i = 0; i < aColumns.length; i++) {
                var lColumn = aColumns[i],
                lCellText = aDataItem[lColumn.DataField];
                if (typeof lColumn.Formatter !== 'undefined' && lColumn.Formatter !== null) {
                    lCellText = lColumn.Formatter(lCellText);
                }

                lTableRow[++lHtmlCounter] = '<td id="';
                lTableRow[++lHtmlCounter] = aListViewId + lColumn.Id + 'Cell' + aIdentifier;
                lTableRow[++lHtmlCounter] = '" class="';
                lTableRow[++lHtmlCounter] = aListViewId + lColumn.Id + 'Cell' + ' ' + aListViewId + lColumn.Id;
                if (typeof lColumn.Hidden !== 'undefined' && lColumn.Hidden) {
                    lTableRow[++lHtmlCounter] = '" style="display:none;';
                }
                lTableRow[++lHtmlCounter] = '">';
                lTableRow[++lHtmlCounter] = lCellText;
                lTableRow[++lHtmlCounter] = '</td>';
            }
            lTableRow[++lHtmlCounter] = '</tr>';
        }
        return lTableRow.join('');
    }

    function UpdateExistingListView(aListView, aDoFilter) {
        //aListView.Filter(null);
        if (isNullOrUndefined(aDoFilter) || aDoFilter) {
            InternalFilter(aListView, mExpression);
        }
        if (typeof mFilteredList !== 'undefined' && mFilteredList != null) {
            var lKey;
            $('.' + aListView.Id + 'DataRow').attr('ToRemove', 'true');
            for (lKey in mFilteredList) {
                if (mFilteredList.hasOwnProperty(lKey)) {
                    var lDataItem = mFilteredList[lKey];
                    if (lDataItem != null) {
                        var lIdentifier = GetDataItemIdentifier(lDataItem, lKey),
                        lListViewItem = $('#' + aListView.Id + 'Row' + lIdentifier);
                        if (lListViewItem.length === 1) {
                            lListViewItem.removeAttr('ToRemove');
                            if (typeof lDataItem !== 'undefined' && lDataItem !== null) {
                                for (i = 0; i < aListView.Columns.length; i++) {
                                    var lColumn = aListView.Columns[i],
                                    lCellText = lDataItem[lColumn.DataField];
                                    if (typeof lColumn.Formatter !== 'undefined' && lColumn.Formatter !== null) {
                                        lCellText = lColumn.Formatter(lCellText);
                                    }
                                    $('#' + aListView.Id + lColumn.Id + 'Cell' + lIdentifier).html(lCellText);
                                }
                            }
                        } else {
                            $(GenerateNewListViewRow(lDataItem, lIdentifier, aListView.Columns)).appendTo(lTableBody);
                        }
                    } else {
                        $('#' + aListView.Id + 'Row' + lKey).remove();
                    }
                }
            }
        }
        $('[ToRemove]').remove();
    }

    function RenderNewListView(aListViewId, aBaseElementId, aColumns, aDataSource, aIsSelectable, aListView) {
        var lTitleText = '',
            lIsHeaderVisible = false,
            lFilterDiv = $('<div/>', {});
        mFilterContentDiv = $('<div/>', {});
        if (typeof aListView.Settings !== 'undefined' && aListView.Settings !== null) {
            if (aListView.Settings.hasOwnProperty('Title')) {
                lTitleText = aSettings.Title;
                lIsHeaderVisible = true;
            }
            if (aListView.Settings.hasOwnProperty('DataFilter')) {
                mDataFilter = aListView.Settings.DataFilter;
            }
            if (aListView.Settings.hasOwnProperty('Identifier')) {
                mIdentifier = aListView.Setting.Identifier;
            }
            if (aListView.Settings.hasOwnProperty('ColumnsFilterable') && aListView.Settings.ColumnsFilterable) {
                lIsHeaderVisible = true;
                lFilterDiv = $('<div/>', {
                    'class': 'SumoListViewColumnFilter'
                });
                var lFilterDivText = $('<div/>', {
                    'html': 'Columns',
                    'class': 'SumoListViewColumnFilterText Clickable'
                })
                .click(function () { ToggleFilterVisibility(this); });

                lFilterDivText.appendTo(lFilterDiv);
                mFilterContentDiv = $('<div/>', {
                    'class': 'SumoListViewColumnFilterContent',
                    'style': 'display: none;'
                });

                if (typeof aColumns !== 'undefined' && aColumns != null && aColumns.length > 0) {
                    // write the header
                    for (i = 0; i < aColumns.length; i++) {
                        var lColumn = aColumns[i],
                            lColumnClass = 'SumoListViewFilterHidden';
                        if (typeof lColumn['IsVisible'] === 'undefined' || lColumn['IsVisible'] === null) {
                            lColumn['IsVisible'] = true;
                        }
                        if (lColumn['IsVisible']) {
                            lColumnClass = 'SumoListViewFilterVisible'
                        }
                        var lColumnSelect = $('<div/>', {
                            'html': lColumn.Title,
                            'class': 'Clickable ' + lColumnClass,
                            'ColumnId': i
                        });
                        lColumnSelect.click(function (aSender) {
                            ToggleColumnVisibility(aListView, aSender)
                        });
                        lColumnSelect.appendTo(mFilterContentDiv);
                        mFilterOptions[i] = lColumnSelect;
                    }
                }
            }
        }

        if (typeof aBaseElementId === 'string') {
            mBaseElement = $('#' + aBaseElementId);
        }
        else {
            mBaseElement = aBaseElementId;
        }

        var i,
            j = -1,
            lTableRows = [],
            lBaseDiv = $('<div/>', {
                'id': aListViewId + 'Component'
            }),
            lHeaderDiv = $('<div/>', {
                'class': 'SumoListViewHeading'
            }),
            lTitleSpan = $('<span/>', {
                'html': lTitleText,
                'class': 'SumoListViewTitle'
            }),
            lTable = $('<table/>', {
                'id': aListViewId,
                'class': 'SumoListView',
                'cellpadding': '0px',
                'cellspacing': '0px'
            }),
            lTableHead = $('<thead/>', {}),
            lTableHeadRow1 = $('<tr/>', {
                'class': 'SumoListViewHeader'
            });
        if (mBaseElement.length === 1) {
            mBaseElement.html('');

            if (typeof aColumns !== 'undefined' && aColumns != null && aColumns.length > 0) {
                // write the header
                for (i = 0; i < aColumns.length; i++) {
                    var lColumn = aColumns[i],
                        lCell = $('<td/>', {
                            'html': lColumn.Title,
                            'class': aListViewId + lColumn.Id,
                            'id': aListViewId + lColumn.Id + 'Header'
                        });
                    if (typeof lColumn.Hidden !== 'undefined' && lColumn.Hidden) {
                        lCell.hide();
                    }
                    $(lCell).appendTo(lTableHeadRow1);
                }

                // vared above
                lTableBody = $('<tbody/>', {});

                if (typeof aDataSource !== 'undefined' && aDataSource != null) {
                    if (mDataFilter !== null) {
                        mFilteredList = query(aDataSource, mDataFilter);
                    } else {
                        mFilteredList = aDataSource;
                    }
                    for (var lKey in mFilteredList) {
                        if (mFilteredList.hasOwnProperty(lKey)) {
                            var lDataItem = aDataSource[lKey],
                            lIdentifier = -1;
                            if (typeof lDataItem !== 'undefined' && lDataItem !== null) {
                                lIdentifier = GetDataItemIdentifier(lDataItem, lKey);
                                lTableRows[j++] = GenerateNewListViewRow(lDataItem, lIdentifier, aColumns);
                                //$(GenerateNewListViewRow(lDataItem, lIdentifier, aColumns)).appendTo(lTableBody);
                            }
                        }
                    }
                    lTableBody.html(lTableRows.join(''));
                }
            }

            if (lIsHeaderVisible) {
                mFilterContentDiv.appendTo(lFilterDiv);
                lFilterDiv.appendTo(lHeaderDiv);
                lTitleSpan.appendTo(lHeaderDiv);
                lHeaderDiv.appendTo(lBaseDiv);
            }
            lTableHeadRow1.appendTo(lTableHead);
            lTableHead.appendTo(lTable);
            if (typeof aIsSelectable !== 'undefined' && aIsSelectable) {
                lTableBody.selectable({
                    stop: OnSelectChange
                });
            }
            lTableBody.appendTo(lTable);
            lTable.appendTo(lBaseDiv);
            lBaseDiv.appendTo(mBaseElement);
        }
    }

    // hypothetical
    this.SetIsSelectable = function (aIsSelectable) {
        if (aIsSelectable) {
            $(lTableBody).selectable({
                stop: OnSelectChange
            })
            .click(testxx);
        }
        else {
            $(lTableBody).selectable("disable");
        }
    }

    function OnSelectChange(event, ui) {
        window[aListViewId + '_OnSelectChange']();
    }

    this.HideColumn = function (aColumnId) {
        $('#' + this.Id + aColumnId + 'Header').hide();
        $('#' + this.Id + aColumnId + 'Cell').hide();
        var i = 0;
        for (i = 0; i < this.Columns.length; i++) {
            if (this.Columns[i].Id === aColumnId) {
                this.Columns[i].Hidden = true;
                break;
            }
        }
    }

    this.ShowColumn = function (aColumnId) {
        $('#' + this.Id + aColumnId + 'Header').show();
        $('#' + this.Id + aColumnId + 'Cell').show();
        var i = 0;
        for (i = 0; i < this.Columns.length; i++) {
            if (this.Columns[i].Id === aColumnId) {
                this.Columns[i].Hidden = false;
                break;
            }
        }
    }

    this.UnselectRowById = function (aItemId) {
        $('#' + this.Id + 'Row' + aItemId).removeClass("ui-selected");
    }

    this.SelectRowById = function (aItemId) {
        $('#' + this.Id + 'Row' + aItemId).addClass("ui-selected");
        var lRow = document.getElementById(this.Id + 'Row' + aItemId);
        if (!isNullOrUndefined(lRow)) {
            lRow.scrollIntoView(false);
        }
    }

    this.SelectRowByIndex = function (aIndex) {
        var lDataRow = $('.' + this.Id + 'DataRow')[aIndex]
        if (typeof lDataRow !== 'undefined' && lDataRow !== null) {
            $(lDataRow).addClass("ui-selected");
        }
    }

    this.RemoveRowById = function (aItemId) {
        $('#' + this.Id + 'Row' + aItemId).remove();
    }

    function InternalFilter(aListView, aExpression) {
        if (!isNullOrUndefined(aExpression)) {
            mFilteredList = query(aListView.DataSource, aExpression);
        } else {
            mFilteredList = aListView.DataSource;
        }
    }

    this.Filter = function (aExpression) {
        var lBuilder = new SumoPredicateBuilder();

        if (aExpression !== null) {
            lBuilder.AddConditional(aExpression, mLogicalOperatorEnum.And())
        }
        if (mDataFilter !== null) {
            lBuilder.AddConditional(mDataFilter, mLogicalOperatorEnum.And())
        }

        //        if (aExpression !== null && mDataFilter !== null) {
        //            mFilterExpression = lBuilder.RootExpression;
        //        } else if (aExpression !== null) {
        //            mFilterExpression = aExpression;
        //        } else {
        //            mFilterExpression = mDataFilter;
        //        }

        //mFilterExpression
        //mExpression = aExpression;
        InternalFilter(this, lBuilder.RootExpression);
        this.RenderContents(false, false);
    }

}


///////////////////////////////////////////////////////////////////////////////////////////////////////
// SumoPagination
///////////////////////////////////////////////////////////////////////////////////////////////////////

function SumoPagination(aDataItemCount, aItemsPerPage, aOnChange, aTarget) {

    this.ItemsPerPage = aItemsPerPage;
    this.OnChange = aOnChange;
    this.TargetElement = aTarget;

    var mPageIndex = 0,
        mDataItemCount = aDataItemCount,
        mPageCount,
        mIsInitialized = false;

    function Initialize(aThis) {
        mPageCount = Math.ceil(mDataItemCount / aThis.ItemsPerPage);
        if (mPageIndex > mPageCount) {
            mPageIndex = 0;
        }
        mIsInitialized = true;
    }

    function ChangePage(aThis, aNewPage) {
        if (mPageIndex !== aNewPage && aNewPage <= mPageCount && aNewPage >= 0) {
            mPageIndex = aNewPage;
            if (!isNullOrUndefined(aThis.OnChange)) {
                aThis.OnChange(aThis.TargetElement, mPageIndex + 1);
            }
        }
    }

    function GetPageNumberView(aThis) {
        var lResult = 0;
        if (mPageCount > 0)
            lResult = mPageIndex + 1;
        return lResult;
    }

    function GeneratePagination(aThis) {
        var lDiv = $('<div/>', {}),
            lPrev = $('<span/>', {
                'html': 'Prev',
                'class': 'Clickable SumoPaginationPrev',
                'title': 'Previous'
            }).click(function (aSender) {
                ChangePage(aThis, mPageIndex - 1);
            }),
            lNext = $('<span/>', {
                'html': 'Next',
                'class': 'Clickable SumoPaginationNext',
                'title': 'Next'
            }).click(function (aSender) {
                ChangePage(aThis, mPageIndex + 1);
            }),
            lPages = $('<span/>', {
                'html': GetPageNumberView() + localizeText('cPagerOf') + mPageCount,
                'class': 'Clickable SumoPaginationPage',
                'title': 'Next'
            }).click(function (aSender) {
                ChangePage(aThis, mPageIndex + 1);
            });

        if (mPageIndex === 0) {
            lPrev.attr("style", "visibility:hidden;");
        }
        if (mPageIndex === mPageCount - 1 || mPageCount === 0) {
            lNext.attr("style", "visibility:hidden;");
        }

        lPages.appendTo(lDiv);
        lNext.appendTo(lDiv);
        lPrev.appendTo(lDiv);
        return lDiv;
    }

    this.SetItemCount = function (aItemCount) {
        mDataItemCount = aItemCount;
        Initialize(this);
    }

    this.RenderContents = function () {
        if (!mIsInitialized) {
            Initialize(this);
        }
        return GeneratePagination(this);
    }
}


///////////////////////////////////////////////////////////////////////////////////////////////////////
// SumoCardView
///////////////////////////////////////////////////////////////////////////////////////////////////////

function SumoCardView(aListId, aBaseElementId, aColumns, aDataSource, aSettings) {
    this.Id = aListId;
    this.BaseElementId = aBaseElementId;
    this.Columns = aColumns;
    this.DataSource = aDataSource;
    this.Settings = aSettings;

    var mIsInitialized = false,
        mIsSelectable = true,
        mOnItemSelect = null,
        mExpression = null,
        mFilteredList = aDataSource,
        mItemsPerPage = 25,
        mPageNumber = 1,
        mPager = null,
        mItems = [];

    function Initialize(aCardView) {
        if (typeof aCardView.Settings !== 'undefined' && aCardView.Settings !== null) {
            if (typeof aCardView.Settings.ItemsPerPage !== 'undefined' && aCardView.Settings.ItemsPerPage !== null) {
                mItemsPerPage = aCardView.Settings.ItemsPerPage;
            }
            if (typeof aCardView.Settings.OnItemSelect !== 'undefined' && aCardView.Settings.OnItemSelect !== null) {
                mOnItemSelect = aCardView.Settings.OnItemSelect;
            }
            if (!isNullOrUndefined(aCardView.Settings.Expression)) {
                mExpression = aCardView.Settings.Expression;
                mFilteredList = query(mFilteredList, mExpression);
            }
            if (!isNullOrUndefined(aCardView.Settings.IsSelectable)) {
                mIsSelectable = aCardView.Settings.IsSelectable;
            }
        }
        mIsInitialized = true;
    }

    function CalculatePages(aList) {
        var lItemCount = 0,
            lKey;
        for (lKey in aList) {
            if (aList.hasOwnProperty(lKey)) {
                lItemCount++;
            }
        }
        return lItemCount;
    }

    function SelectItem(aCardViewId, aItemId) {
        if (mIsSelectable) {
            var lItem = $('#' + aCardViewId + 'Row' + aItemId);
            if (lItem.length === 1) {
                $('#' + aCardViewId + ' .SumoCardViewSelected').removeClass('SumoCardViewSelected');
                lItem.addClass('SumoCardViewSelected');
                if (mOnItemSelect !== null) {
                    mOnItemSelect(aItemId);
                }
            }
        }
    }

    function DataRow_OnClick(aCardView, aSender) {
        var lRowId = aSender.target.getAttribute('RowId');
        SelectItem(aCardView.Id, lRowId);
    }

    function UpdatePaginationRow(aCardView) {
        var lCell = $('#' + aCardView.Id + 'PaginationCell'),
            lPager,
            lItemCount = CalculatePages(mFilteredList);
        mPager.SetItemCount(lItemCount);
    }

    function GeneratePaginationRow(aCardView) {
        var lRow = $('<tr/>', {
            'id': aCardView.Id + 'PaginationRow',
            'class': 'SumoDataGridPaginationRow'
        }),
            lCell = $('<td/>', {
                'id': aCardView.Id + 'PaginationCell',
                'colspan': aCardView.Columns.length
            }),
            lPager;

        if (mPager === null) {
            var lItemCount = CalculatePages(mFilteredList);
            mPager = new SumoPagination(lItemCount, mItemsPerPage, GenerateNewDataList, aCardView);
        }
        lPager = mPager.RenderContents();
        lPager.appendTo(lCell);
        lCell.appendTo(lRow);
        return lRow;
    }

    function GenerateEmptyDataSetRow(aCardView) {
        var lSpan = $('<span/>', { 'class': 'EmptyDataSet', 'html': localizeText('cNoMatchingRecords') });
        return lSpan;
    }

    function GenerateNewDataRow(aCardView, aDataItem) {
        var lRow = $('<tr/>', {
            'id': aCardView.Id + 'Row' + aDataItem.Id,
            'class': 'Clickable ' + aCardView.Id + 'Row SumoDataGridDataRow'
        }).attr('RowId', aDataItem.Id),
            lColumn,
            lCell,
            lKey,
            lColumns = aCardView.Columns
            lInnerHtml = '';
        for (lKey in lColumns) {
            if (lColumns.hasOwnProperty(lKey)) {
                lColumn = aCardView.Columns[lKey];
                if (typeof lColumn.Generator !== 'undefined' && lColumn.Generator !== null) {
                    lInnerHtml = lColumn.Generator(aDataItem);
                }
                lCell = $('<td/>', {
                    'html': lInnerHtml,
                    'class': aCardView.Id + lColumn.Id + 'Cell',
                    'id': aCardView.Id + lColumn.Id + 'Cell' + aDataItem.Id
                }).attr('RowId', aDataItem.Id);
                lCell.appendTo(lRow);
            }
        }
        lRow.click(function (aSender) {
            DataRow_OnClick(aCardView, aSender);
        });
        return lRow;
    }

    function AddTableToElement(aCardView, aTable) {
        var lBaseElement = $('#' + aCardView.BaseElementId);
        lBaseElement.html('');
        aTable.appendTo(lBaseElement);
        var lItem = mItems[0];
        if (typeof lItem !== 'undefined') {
            SelectItem(aCardView.Id, lItem.Id);
        }
    }

    function GenerateNewDataList(aCardView, aPageNumber) {
        if (typeof aPageNumber !== 'undefined' && aPageNumber !== null) {
            mItems = [];
            var lKey,
                lTable = $('<table/>', {
                    'id': aCardView.Id,
                    'class': 'SumoDataGrid',
                    'cellspacing': '0px',
                    'cellpadding': '0px'
                }),
                lInternalPageNumber = aPageNumber - 1,
                lStartingIndex = lInternalPageNumber * mItemsPerPage,
                lEndingIndex = lStartingIndex + mItemsPerPage,
                lItemCounter = 0,
                lDataItem,
                lDataRow,
                lPaginationRow = GeneratePaginationRow(aCardView),
                lBaseElement = $('#' + aCardView.BaseElementId);
            lPaginationRow.appendTo(lTable);

            for (lKey in mFilteredList) {
                if (mFilteredList.hasOwnProperty(lKey)) {
                    if (lItemCounter >= lStartingIndex && lItemCounter < lEndingIndex) {
                        lDataItem = mFilteredList[lKey];
                        lDataRow = GenerateNewDataRow(aCardView, lDataItem);
                        mItems.push(lDataItem);
                        lDataRow.appendTo(lTable);
                    }
                    lItemCounter++;
                }
            }
            AddTableToElement(aCardView, lTable);
            if (lItemCounter === 0) {
                $(GenerateEmptyDataSetRow()).appendTo(lBaseElement);
                lPaginationRow.remove();
            }
        }
    }

    this.RenderContents = function (aPageNumber) {
        if (!mIsInitialized) {
            Initialize(this);
        }
        GenerateNewDataList(this, aPageNumber);
    }

    this.SelectItemById = function (aId) {
        SelectItem(this.Id, aId);
    }

    this.SelectItemByIndex = function (aIndex) {
        var lItem = mItems[aIndex];
        if (typeof lItem !== 'undefined') {
            SelectItem(this.Id, lItem.Id);
        }
    }

    this.Filter = function (aExpression) {
        mExpression = aExpression;
        if (mExpression !== null) {
            var lBuilder = new SumoPredicateBuilder();
            lBuilder.AddConditional(mExpression, mLogicalOperatorEnum.And());
            lBuilder.AddConditional(aExpression, mLogicalOperatorEnum.And());
        } else {
            mFilteredList = query(this.DataSource, aExpression);
        }
        UpdatePaginationRow(this);
        this.RenderContents(1);
    }

}

///////////////////////////////////////////////////////////////////////////////////////////////////////
// RequestManager
///////////////////////////////////////////////////////////////////////////////////////////////////////

function RequestManager() {
    "use strict";
    var mRequestId = 0;

    this.getRequestId = function () {
        return mRequestId++;
    };
}



///////////////////////////////////////////////////////////////////////////////////////////////////////
// Sumo Activity Notification
///////////////////////////////////////////////////////////////////////////////////////////////////////

function SumoActivityNotification(aElementId, aBaseElementId, aWaitTime, aOptions) {
    "use strict";
    this.Id = aElementId;
    this.BaseElementId = aBaseElementId;
    this.WaitTime = aWaitTime;

    //    var mIsInitialized = false,
    //        mNotification = null,
    //        mTimerId = null,
    //        mNotificationList = [],
    //        mNotificationCounter = 0,
    //        mActiveCounter = 0;

    // DECLARATIONS
    var mThis = this,
        mIsInitialized = false,
        mIsRendered = false,
        mActivityNotification = null,
        mActivityNotificationContent = null,
        mNotificationList = [],
        mTimerIds = [],
        mNotificationCounter = 0,
        mActiveNotifications = 0,
        mOptions = {};
        
    // REMOVE
    function removeNotificationInternal(aNotification) {
        aNotification.remove();
    }

    function clearTimer(aNotificationId) {
        var lId = mTimerIds[aNotificationId];
        if (!isNullOrUndefined(lId)) {
            window.clearTimeout(lId);
            mTimerIds[aNotificationId] = null;
        }
    }

    function closePanel() {
        if (mActiveNotifications === 0) {
            mActivityNotification.fadeOut(1500, 'linear', function () { mActivityNotificationContent.html(''); });
            //mActivityNotification.hide('slow');
        }
    }

    function removeFromList(aNotificationId) {
        mNotificationList[aNotificationId] = null;
        --mActiveNotifications;
        if (mActiveNotifications === 0) {
            window.setTimeout(closePanel, 750);
            //closePanel();
        }
    }

    function clearNotification(aNotificationId) {
        var lNotification = mNotificationList[aNotificationId];
        if (!isNullOrUndefined(lNotification)) {
            removeNotificationInternal(lNotification);
            clearTimer(aNotificationId);
            removeFromList(aNotificationId);
        }
    }

    // EVENTS
    function onCloseClick() {
        var lItem,
            lKey;

        for (lKey in mNotificationList) {
            if (mNotificationList.hasOwnProperty(lKey)) {
                lItem = mNotificationList[lKey];
                if (!isNullOrUndefined(lItem)) {
                    clearNotification(lKey);
                }

            }
        }

    }

    // INITIALIZATION
    function initialize() {
        var lCloseButton;

        if (!mIsInitialized) {
            if (isNullOrUndefined(mThis.WaitTime)) {
                mThis.WaitTime = 5000;
            } else {
                //mThis.WaitTime = mThis.WaitTime * 1000;
            }
            if (!isNullOrUndefined(aOptions)) {
                if (!isNullOrUndefined(aOptions.allowClose)) {
                    mOptions.allowClose = aOptions.allowClose;
                } else {
                    mOptions.allowClose = false;
                }
                if (!isNullOrUndefined(aOptions.allowLocalization)) {
                    mOptions.allowLocalization = aOptions.allowLocalization;
                } else {
                    mOptions.allowLocalization = true;
                }

            }
            mActivityNotification = $('<div/>', {
                'id': mThis.Id, 
                'class': 'SumoActivityNotification',
                'style': 'display: none;'
            });


            if (mOptions.allowClose) {
                lCloseButton = $('<div/>', {
                    'id': mThis.Id + 'Close',
                    'class': 'SumoActivityNotificationClose'                    
                });
                lCloseButton.click(onCloseClick);
                mActivityNotification.append(lCloseButton);
            }

            mActivityNotificationContent = $('<div/>', {
                'id': mThis.Id + 'Content',
                'class': 'SumoActivityNotificationContent'
            });
            mActivityNotification.append(mActivityNotificationContent);

            mIsInitialized = true;
        }
    }

    function createActivityNotification(aNotification) {
        var lBaseElement = $('#' + aNotification.BaseElementId);
        mActivityNotification.appendTo(lBaseElement);
        mIsRendered = true;
    }

    function updateActivityNotification(aNotification) {
        var l = aNotification;
    }

    // CREATE
    function createNotification(aContent) {
        var lNotification = $('<div/>', {
            'html': aContent,
            'class': 'NotificationItem'
        });
        return lNotification;
    }

    function displayNotification(aNotification) {
        if (!mActivityNotification.is(':visible')) {
            mActivityNotification.fadeIn(1500, 'linear');
        }
        aNotification.appendTo(mActivityNotificationContent);
        aNotification[0].scrollIntoView(false);
        if (!aNotification.is(':visible')) {
            $(window).resize();
        }
        if (mOptions.allowLocalization) {
            veritracks.localization.localize(aNotification);
        }
    }

    function addToList(aNotification, aNotificationId) {
        mNotificationList[aNotificationId] = aNotification;
        ++mActiveNotifications;
    }

    function createTimer(aNotificationId, aIsSticky) {
        if (isNullOrUndefined(aIsSticky) || !aIsSticky) {
            mTimerIds[aNotificationId] = window.setTimeout(function () {
                clearNotification(aNotificationId);
            }, mThis.WaitTime);
        }
    }

    // EXTERNAL
    this.render = function () {
        initialize();
        if (mIsRendered) {
            updateActivityNotification(this);
        } else {
            createActivityNotification(this);
        }
    };

    this.addNotification = function (aContent, aIsSticky, aDoDisplay) {
        if (isNullOrUndefined(aDoDisplay) || aDoDisplay) {
            var lNotification = createNotification(aContent),
            lNotificationId = ++mNotificationCounter;
            addToList(lNotification, lNotificationId);
            createTimer(lNotificationId, aIsSticky);
            displayNotification(lNotification);
            return lNotificationId;
        }
    };

    this.removeNotification = function (aNotificationId) {
        clearNotification(aNotificationId);
    };

    this.clearNotifications = function () {
        onCloseClick();
    };

    this.dispose = function () {
        mActivityNotificationContent.remove();
        mActivityNotificationContent = null;

        mActivityNotification.remove();
        mActivityNotification = null;

        mNotificationList = null;
        mTimerIds = null;
        mOptions = null;
        mThis = null;
    };
}


///////////////////////////////////////////////////////////////////////////////////////////////////////
// Sumo Dual List Assignment
///////////////////////////////////////////////////////////////////////////////////////////////////////

function SumoDualListAssignment(
    aId,
    aLeftData,
    aRightData,
    aLeftPrimaryExpression,
    aRightPrimaryExpression,
    aLeftSecondaryPredicateColumnName,
    aRightSecondaryPredicateColumnName,
    aLeftTitle,
    aRightTitle,
    aLeftColumns,
    aRightColumns) {

    var mLeftData,
        mRightData,
        mLeftSelectedIndexes,
        mRightSelectedIndexes,
        mLeftPredicateBuilder = new SumoPredicateBuilder(),
        mTable = $('<table/>', {
            'id': aId,
            'width': '100%'
        }),
        mHeaderRow = $('<tr/>', {}),
        mHeaderCell1 = $('<td/>', {
            'html': aLeftTitle,
            'width': '45%'
        }),
        mHeaderCell2 = $('<td/>', {}),
        mHeaderCell3 = $('<td/>', {
            'html': aRightTitle,
            'width': '45%'
        }),
        mContentRow = $('<tr/>', {}),
        mContentCell1 = $('<td/>', {
            'html': '[LEFT] Grid',
            'id': aId + 'LeftGridCell',
            'width': '45%',
            'class': 'Scrollable',
            'style': 'vertical-align: top; max-height: 200px; height: 150px;'
        }),
        mContentCell2 = $('<td/>', {}),
        mContentCell3 = $('<td/>', {
            'html': '[RIGHT] Grid',
            'id': aId + 'RightGridCell',
            'width': '45%',
            'class': 'Scrollable PopupList',
            'style': 'vertical-align: top; max-height: 200px;'
        }),
        mRightButton = GenerateSmallButton('>>', '', '')
                       .click(function () { MoveRightButton_OnClick(); }),
        mLeftButton = GenerateSmallButton('<<', '', '')
                      .click(function () { MoveLeftButton_OnClick(); });

    if (typeof aRightPrimaryExpression !== 'undefined' && aRightPrimaryExpression !== null) {
        mRightData = query(aRightData, aRightPrimaryExpression);
    } else {
        mRightData = aRightData;
    }
    mLeftPredicateBuilder.AddConditional(aLeftPrimaryExpression);
    //mLeftPredicateBuilder.AddNewExpressionConditional(aLeftSecondaryPredicateColumnName, 'mRightData', false, mRelationalOperatorEnum.NotIn(), mLogicalOperatorEnum.And());
    mLeftData = query(aLeftData, mLeftPredicateBuilder.RootExpression);

    mLeftListView = new SumoListView(
        aId + 'LeftListView',
        mContentCell1,
        aLeftColumns,
        mLeftData,
        true,
        null);
    mLeftListView.RenderContents(true);

    mRightListView = new SumoListView(
        aId + 'RightListView',
        mContentCell3,
        aRightColumns,
        mRightData,
        true,
        { 'Identifier': aRightSecondaryPredicateColumnName, 'DataFilter': aRightPrimaryExpression });
    mRightListView.RenderContents(true);

    mRightButton.appendTo(mContentCell2);
    mLeftButton.appendTo(mContentCell2);
    mHeaderCell1.appendTo(mHeaderRow);
    mHeaderCell2.appendTo(mHeaderRow);
    mHeaderCell3.appendTo(mHeaderRow);
    mContentCell1.appendTo(mContentRow);
    mContentCell2.appendTo(mContentRow);
    mContentCell3.appendTo(mContentRow);
    mHeaderRow.appendTo(mTable);
    mContentRow.appendTo(mTable);

    window[aId + 'LeftListView_OnSelectChange'] = function () {
        var lSelected = $('#' + aId + 'LeftListView tr.ui-selected');
        mLeftSelectedIndexes = [];
        for (i = 0; i < lSelected.length; i++) {
            lRowId = lSelected[i].id;
            lRowId = lRowId.substring((aId + 'LeftListViewRow').length, lRowId.length);
            mLeftSelectedIndexes.push(lRowId);
        }
    }

    window[aId + 'RightListView_OnSelectChange'] = function () {
        var lSelected = $('#' + aId + 'RightListView tr.ui-selected');
        mRightSelectedIndexes = [];
        for (i = 0; i < lSelected.length; i++) {
            lRowId = lSelected[i].id;
            lRowId = lRowId.substring((aId + 'RightListViewRow').length, lRowId.length);
            mRightSelectedIndexes.push(lRowId);
        }
    }

    function MoveRightButton_OnClick() {
        for (lKey in mLeftSelectedIndexes) {
            if (mLeftSelectedIndexes.hasOwnProperty(lKey)) {
                var lId = mLeftSelectedIndexes[lKey],
                lItem = mLeftData[lId];
                mRightData[lId] = lItem;
                mLeftData[lId] = null;
            }
        }
        mLeftListView.RenderContents(false);
        mRightListView.RenderContents(false);
    }

    function MoveLeftButton_OnClick() {
        for (lKey in mRightSelectedIndexes) {
            if (mRightSelectedIndexes.hasOwnProperty(lKey)) {
                var lId = mRightSelectedIndexes[lKey],
                lItem = mRightData[lId];
                mLeftData[lId] = lItem;
                mRightData[lId] = null;
            }
        }
        mLeftListView.RenderContents(false);
        mRightListView.RenderContents(false);
    }

    this.ToElement = function () {
        return mTable;
    }

    this.LeftData = function () {
        return mLeftData;
    }

    this.RightData = function () {
        return mRightData;
    }
}

///////////////////////////////////////////////////////////////////////////////////////////////////////
// Universal Search
///////////////////////////////////////////////////////////////////////////////////////////////////////

function UniversalSearch(aDatasets, aMaxResultCount, aAdvancedSearching) {
    var mThis = this,
        mText = null,
        mResultsDiv = null,
        mDatasets = aDatasets,
        mDefaultValue = localizeText('cFindAnything'),
        mMaxResultCount = aMaxResultCount,
        mFocusTimerManager = new TimerManager(500),
        mSearchTimerManager = new TimerManager(500),
        mAdvancedSearching = aAdvancedSearching,
        mBuilder = new SumoPredicateBuilder();

    this.SelectedId = null;
    this.SelectedHash = null;

    if (isNullOrUndefined(mMaxResultCount)) {
        mMaxResultCount = 50;
    }

    function mSearchTimerManager_Complete(aSearchString) {
        var lIndex,
            i,
            lDataItem,
            lProperty,
            lResults = new Array(),
            lLocalResults = null;

        for (lIndex in mDatasets) {
            if (mDatasets.hasOwnProperty(lIndex)) {
                mBuilder.Clear();
                lDataItem = mDatasets[lIndex];
                for (lProperty in lDataItem.SearchFields) {
                    if (lDataItem.SearchFields.hasOwnProperty(lProperty)) {
                        mBuilder.AddNewExpressionConditional(lDataItem.SearchFields[lProperty], aSearchString, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.Or());
                    }
                }
                if (!isNullOrUndefined(lDataItem.Expression)) {
                    mBuilder.AddConditional(lDataItem.Expression, mLogicalOperatorEnum.And());
                }
                lLocalResults = query(lDataItem.DataSource, mBuilder.RootExpression);
                if (count(lLocalResults) > 0) {
                    for (i in lLocalResults) {
                        if (lLocalResults.hasOwnProperty(i)) {
                            lResults.push({
                                'Hash': lDataItem.Hash,
                                'Title': lDataItem.Title,
                                'Class': lDataItem.Class,
                                'Class2': lDataItem.Class2,
                                'ValueField': lDataItem.ValueField,
                                'Generator': lDataItem.Generator,
                                'DataItem': lLocalResults[i]
                            });
                            if (lResults.length >= mMaxResultCount) {
                                break;
                            }
                        }
                    }
                }
                if (lResults.length >= mMaxResultCount) {
                    break;
                }
            }
        }
        mResultsDiv.html('');
        if (lResults.length > 0) {
            RenderResults(lResults, aSearchString);
        }
    }

    //function ResultClick(aEvent) {
    //    mThis.SelectedId = aEvent.target.getAttribute("ItemId");
    //    mThis.SelectedHash = aEvent.target.getAttribute("Hash");

    //    window.location.hash = mThis.SelectedHash + "." + mThis.SelectedId.toString();

    //    Clear(mThis);
    //    SetDefaultText();
    //}

    function ResultClick(aEvent) {
        mThis.SelectedId = aEvent.data.Id;
        mThis.SelectedHash = aEvent.data.Hash;

        if (aEvent.data.Title === 'Enrollees') {
            mThis.SelectedHash = fixHashOffendersVictim(mThis.SelectedId, mThis.SelectedHash);
        }
        if (mAdvancedSearching){
            if(!checkAdvancedSearchIsNeeded(aEvent.data.Title, mThis.SelectedHash, mThis.SelectedId))
                window.location.hash = mThis.SelectedHash + "." + mThis.SelectedId.toString();
        }
        else{
            window.location.hash = mThis.SelectedHash + "." + mThis.SelectedId.toString();
        }
        Clear();
        SetDefaultText();
    }

    // V11 specific code for Advanced searching for things not in cache.

    function RenderResults(aResultSet, aSearchString) {
        var lIndex,
            lItemDiv,
            lItem,
            lHtml,
            lMatches,
            lMatchIndex,
            lMatch,
            lRegExMatch;
        for (lIndex in aResultSet) {
            if (aResultSet.hasOwnProperty(lIndex)) {
                lItem = aResultSet[lIndex];
                if (!isNullOrUndefined(lItem.Generator)) {
                    lHtml = lItem.Generator(lItem.DataItem);
                } else if (!isNullOrUndefined(lItem.ValueField)) {
                    lHtml = lItem.DataItem[lItem.ValueField];
                } else {
                    lHtml = '';
                }
                lRegExMatch = lHtml.match(new RegExp(aSearchString, 'gi'));
                if (!isNullOrUndefined(lRegExMatch)) {
                    lMatches = $.unique(lRegExMatch);
                    for (lMatchIndex in lMatches) {
                        if (lMatches.hasOwnProperty(lMatchIndex)) {
                            lMatch = lMatches[lMatchIndex];
                            lHtml = lHtml.replace(new RegExp(lMatch, 'gi'), '<span class="Q">' + lMatch + '</span>');
                        }
                    }
                }
                if (!isNullOrUndefined(lItem.Class2)) {
                    if (lItem.DataItem.InMyOrganization) {
                        lItemDiv = $('<div/>', {
                            'html': lHtml,
                            'class': lItem.Class2 + ' Clickable TextLimit'
                        }).click({ 'Hash': lItem.Hash, 'Id': lItem.DataItem.Id, 'Title': lItem.Title  }, ResultClick);
                        lItemDiv.appendTo(mResultsDiv);
                    } else {
                        lItemDiv = $('<div/>', {
                            'html': lHtml,
                            'class': lItem.Class + ' Clickable TextLimit'
                        }).click({ 'Hash': lItem.Hash, 'Id': lItem.DataItem.Id, 'Title': lItem.Title }, ResultClick);
                        lItemDiv.appendTo(mResultsDiv);
                    }
                } else {
                    lItemDiv = $('<div/>', {
                        'html': lHtml,
                        'class': lItem.Class + ' Clickable TextLimit'
                    }).click({ 'Hash': lItem.Hash, 'Id': lItem.DataItem.Id, 'Title': lItem.Title }, ResultClick);
                    lItemDiv.appendTo(mResultsDiv);
                }
            }
        }
        mResultsDiv.show();
    }

    function SetDefaultText() {
        if (mText.val() === '') {
            mText.val(mDefaultValue);
        }
    }

    function Clear() {
        mSearchTimerManager.StopTimer();
        mResultsDiv.hide();
        mText.val('');
    }

    function mFocusTimerManager_OnComplete() {
        Clear();
        SetDefaultText();
    }

    function mText_OnKeyUp(aEvent) {
        var lValue = $.trim(mText.val());
        if (lValue === '' || lValue === mDefaultValue) {
            Clear();
        }
        else {
            mSearchTimerManager.SetTimer(function () { mSearchTimerManager_Complete(lValue); });
        }
    }

    function mText_OnFocus(aEvent) {
        mFocusTimerManager.StopTimer();
        if (mText.val() === mDefaultValue) {
            mText.val('');
        }
    }

    function mText_OnBlur(aEvent) {
        if (!mResultsDiv.is(':focus')) {
            mFocusTimerManager.SetTimer(mFocusTimerManager_OnComplete);
        }
    }

    function mResultsDiv_OnFocus(aEvent) {
        mFocusTimerManager.StopTimer();
    }

    function mResultsDiv_OnBlur(aEvent) {
        if (!mText.is(':focus')) {
            mFocusTimerManager.SetTimer(mFocusTimerManager_OnComplete);
        }
    }

    this.RenderContents = function (aParent) {
        mText = $('<input/>', { 'type': 'text', 'id': 'uUniversalSearchText', 'value': mDefaultValue })
            .keyup(function (aEvent) { mText_OnKeyUp(aEvent) })
            .focus(function (aEvent) { mText_OnFocus(aEvent) })
            .blur(function (aEvent) { mText_OnBlur(aEvent) });
        mResultsDiv = $('<div/>', { 'class': 'Scrollable', 'id': 'uUniversalSearchResults' })
            .focus(function (aEvent) { mResultsDiv_OnFocus(aEvent) })
            .blur(function (aEvent) { mResultsDiv_OnBlur(aEvent) });
        var mResultsDivBacking = $('<div/>', { 'class': 'Scrollable', 'id': 'uUniversalSearchResults' });
        mText.appendTo(aParent);
        mResultsDiv.appendTo(aParent);
    };
}

///////////////////////////////////////////////////////////////////////////////////////////////////////
// TimerManager
///////////////////////////////////////////////////////////////////////////////////////////////////////

function TimerManager(aTimeout) {
    this.Timeout = aTimeout;

    var mTimerId = -1,
        mReplacementCallback = null;

    this.StopTimer = function (aIsReplacement) {
        if (mTimerId !== -1) {
            window.clearInterval(mTimerId);
            if(aIsReplacement && !isNullOrUndefined(mReplacementCallback)){
                mReplacementCallback(mTimerId);
            }
        }
        mTimerId = -1;
    }

    this.SetTimer = function (aCallback, aParams, aReplacementCallback) {
        this.StopTimer(true);
        if (!isNullOrUndefined(aReplacementCallback)) {
            mReplacementCallback = aReplacementCallback;
        }
        mTimerId = window.setTimeout(function () { aCallback(aParams); mReplacementCallback = null; }, this.Timeout);
        return mTimerId;
    }

}


///////////////////////////////////////////////////////////////////////////////////////////////////////
// Sumo Notes Manager
///////////////////////////////////////////////////////////////////////////////////////////////////////

function SumoNotesManager(aElementId, aBaseElementId, aNotesList, aSettings) {
    this.Id = aElementId;
    this.BaseElementId = aBaseElementId;
    this.NotesList = aNotesList;
    this.Settings = aSettings;

    var mCardView = null,
        mOnAdd = null,
        mIdentificationProperty = 'Id',
        mIdentifier = -1,
        mUserId = -1,
        mPermissionId = -1,
        mPermission,
        mPermissionLevel = 2,
        mTextArea = null;
    var mClassName = '';
    var mClassNameSuffix = ':www.veritracks.com';


    function Initialize(aThis) {
        if (!isNullOrUndefined(aThis.Settings.ClassNameSuffix)) {
            mClassNameSuffix = aThis.Settings.ClassNameSuffix;
        }
        if (!isNullOrUndefined(aThis.Settings.ClassName)) {
            mClassName = aThis.Settings.ClassName;
        }
        if (!isNullOrUndefined(aThis.Settings.OnAdd)) {
            mOnAdd = aThis.Settings.OnAdd;
        }
        if (!isNullOrUndefined(aThis.Settings.IdentificationProperty)) {
            mIdentificationProperty = aThis.Settings.IdentificationProperty;
        }
        if (!isNullOrUndefined(aThis.Settings.Identifier)) {
            mIdentifier = aThis.Settings.Identifier;
        }
        if (!isNullOrUndefined(aThis.Settings.UserId)) {
            mUserId = aThis.Settings.UserId;
        }
        if (!isNullOrUndefined(aThis.Settings.PermissionId)) {
            mPermissionId = aThis.Settings.PermissionId;
            mPermission = gUserPermissions[mPermissionId];
            if (!isNullOrUndefined(mPermission)) {
                mPermissionLevel = mPermission.Value;
            }
        }
        mTextArea = $('<textarea/>', { 'id': 'uAddNoteTextArea', 'class': 'AddNoteTextArea', 'width': '490px', 'onkeyup': 'noteManager_OnChange()' });

    }



    function AddNoteManagerOkButton_OnClick() {
        var lNote = new Note(mUserId, mTextArea.val()),
            lNoteList = [],
            lKey;
        if ($.trim(lNote.Content).length > 0 && $.trim(lNote.Content).length <= 3000) {
            if (!isNullOrUndefined(mOnAdd)) {
                if (typeof mIdentifier === 'number' || typeof mIdentifier === 'string') {
                    lNote[mIdentificationProperty] = mIdentifier;
                    lNote['__type'] = mClassName + 'Note' + mClassNameSuffix;
                    mOnAdd(lNote);
                } else {
                    for (lKey in mIdentifier) {
                        if (mIdentifier.hasOwnProperty(lKey)) {
                            lNote = new Note(mUserId, mTextArea.val());
                            lNote[mIdentificationProperty] = mIdentifier[lKey];
                            lNote['__type'] = mClassName + 'Note' + mClassNameSuffix;
                            lNoteList.push(lNote);
                        }
                    }
                    mOnAdd(lNoteList);
                }
            }
            $('#uAddNoteTextArea').removeClass('ValidateSuccess');
            mTextArea.val('');
            ClosePopup();
        } else {
            if ($.trim(lNote.Content).length > 3000) {
                mActivityNotification.addNotification(localizeWrapper('cEnrolleeNoteLengthError'));
            } else {
                $('#uAddNoteTextArea').addClass('ValidateError');
            }
        }
    }

    function AddNoteManagerCancelButton_OnClick() {
        $('#uAddNoteTextArea').removeClass('ValidateSuccess').removeClass('ValidateError');
        ClosePopup();
    }

    function AddNoteManagerButton_OnClick() {
        var lButtons = GenerateButtonCommandBar(),
            lOkButton = GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', AddNoteManagerOkButton_OnClick),
            lCancelButton = GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', AddNoteManagerCancelButton_OnClick);

        lOkButton.appendTo(lButtons);
        lCancelButton.appendTo(lButtons);

        DisplayPopup(localizeWrapper('cEnrolleeAddNewNote'), mTextArea, lButtons, true);
    }

    function NoteListView_OnSelectChange() {
        var l = '';
    }

    function NoteDetailsGenerator(aNote) {
        var lMasterDiv = $('<div/>', {}),
            lDateDiv,
            lCreatorDiv,
            lTextDiv = $('<div/>', { 'text': aNote.Content || aNote.MonitoredEventNote });
        // format for long characters
        lTextDiv.addClass('NoteFormatter');
        if (!isNullOrUndefined(aNote.CreatedDateUTC)) {
            lDateDiv = $('<div/>', { 'text': DisplayShortDateTime(aNote.CreatedDateUTC) });
            lDateDiv.appendTo(lMasterDiv);
        }
        if (!isNullOrUndefined(aNote.UserId)) {
            if (aNote.UserId != "") {
                lCreatorDiv = $('<div/>', { 'text': UserNameFormatter(aNote.UserId) })
                lCreatorDiv.appendTo(lMasterDiv);
            }
        }

        //lDateDiv.appendTo(lMasterDiv);
        //lCreatorDiv.appendTo(lMasterDiv);
        lTextDiv.appendTo(lMasterDiv);

        return lMasterDiv;
    }

    this.RenderContents = function () {
        Initialize(this);

        var lMasterDiv = $('<div/>', {
            'id': this.Id
        }),
            lButtonBar = $('<div/>', {
                'class': 'ButtonBar'
            }),
            lAddNoteButton = GenerateButton(localizeWrapper('cEventNewNote'), 'Add', AddNoteManagerButton_OnClick),
            lCardViewHolder = $('<div/>', {
                'id': this.Id + 'ListViewHolder'
            }),
            lDataSource,
            lSort = new SortExpression();


        if (mPermissionLevel === 2) {
            lAddNoteButton.appendTo(lButtonBar);
        }
        lButtonBar.appendTo(lMasterDiv);
        lCardViewHolder.appendTo(lMasterDiv);
        lMasterDiv.appendTo($('#' + this.BaseElementId).html(''));
        lDataSource = this.NotesList;
        lSort.addDescendingColumn('CreatedDateUTC');
        lDataSource = lSort.sort(lDataSource);
        this.NotesList = lDataSource;
        mCardView = new SumoCardView(this.Id + 'ListView', this.Id + 'ListViewHolder', [
                { 'Id': 'Details', 'Generator': NoteDetailsGenerator }
        ], this.NotesList, {
            'IsSelectable': false
        });
        $('#' + this.Id + 'ListViewHolder').css('max-height', '400px')
                                    .css('overflow-y', 'auto');
        veritracks.localization.localize('#' + this.Id);
        mCardView.RenderContents(1);
    };

    this.displayPopup = function () {
        AddNoteManagerButton_OnClick();
    };

};


//#region Sumo State Manager

///////////////////////////////////////////////////////////////////////////////////////////////////////
// Sumo State Manager
///////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * 
 * This Class is used globally in variable mStateManager
 *  
 * @constructor
 * @param  {} aElementId
 * 
 * @example
 * var mStateManager = new SumoStateManager('mStateManager');
 */
var SumoStateManager = (function(){
    function SumoStateManager(aElementId) {
        this.Id = aElementId;
        /**
         * Get Current Tab in the Hash
         * @example
         *  switch (mStateManager.Tab()) {
                case 'Dashboard':
                    resetContentHoldersDashboard(lWindowHeight, lMasterWidth);
                    break;
                case 'Enrollees':
                    resetContentHoldersEnrollees(lWindowHeight, lMasterWidth);
                    break;
            }
         */
        this.Tab = function () { return mCurrentHash.Tab; }
        /**
         * Settings
         * Get Current Tab Settings
         */
        this.Settings = function () { return mCurrentHash.Settings; }
        /**
         * Settings
         * Get Current Full current Hash returns an object:
         * @example
         *  mStateManager.Hash();
         *  { Tab: "Dashboard", Settings:[]} 
         */
        this.Hash = function () { return mCurrentHash; }
        /**
         * Get if Tab has change from  previous selection.
         */
        this.IsTabChange = function () { return mCurrentHash.Tab !== mPreviousHash.Tab; }
        /**
         * Get if Settings has change from previous selection.
         */
        this.IsSettingsChange = function (aSettingId) { return mCurrentHash.Settings[aSettingId] !== mPreviousHash.Settings[aSettingId]; }
        var mCurrentHash = {},
            mPreviousHash = {},
            mThis = this,
            mIsInitialized = false,
            mUserRole;
        this.setUserRole = function (aUserRole) {
            mUserRole = aUserRole;
        }
        function GetPrimaryHash() {
            var lClassName = window.location.hash,
                lPreferences = getUserPreferences(10);
            if (lClassName.indexOf('.') !== -1) {
                lClassName = lClassName.substring(1, lClassName.indexOf('.'));
            } else {
                lClassName = lClassName.substring(1, lClassName.length);
            }
            if (lClassName === '') {
                lClassName = 'Dashboard';
                if (!isNullOrUndefined(mUserRole)) {
                    if (mUserRole == 2) {
                        lClassName = 'Analysis';
                    }
                    // logged in top level cdcr....
                    if (mUserRole == 3) {
                        lClassName = 'Enrollees';
                    }
                }
            }
            return lClassName;
        }
    
        function GetSecondaryHash() {
            var lSettingsString = window.location.hash,
            lSettings;
            if (lSettingsString.indexOf('.') !== -1) {
                lSettingsString = lSettingsString.substring(lSettingsString.indexOf('.') + 1, lSettingsString.length);
                lSettings = lSettingsString.split(".");
            } else {
                lSettings = [];
            }
            return lSettings;
        }
        
        function GetCurrentHash() {
            var lHash = {};
            lHash.Tab = GetPrimaryHash();
            lHash.Settings = GetSecondaryHash();
            $('#uDebugOutput').text(lHash.Tab + ' - ' + lHash.Settings);
            return lHash;
        }
        /**
         * Initialize StateManager & It triggers Hash_OnChange() once.
         * @example
         * mStateManager.Initialize();
         */
        this.Initialize = function () {
            if (!mIsInitialized) {
                mIsInitialized = true;
                Hash_OnChange();
            }
        };
        /**
         * This Function will change the Hash and select a new one.
         * @example
         * mStateManager.ChangeHash('Dashboard');
         */
        this.ChangeHash = function (aHash) {        
            window.location.hash = encodeURI(aHash);
    
            // renewing security token cookie
            veritracks.security.controller.extendSession();
        };
        /**
         * Change Hash Settings & automatically will triger ChangeHash
         * new hash is currentTab +"."+ aNewValue
         * @parameter  aIndex
         * @parameter  aNewValue
         * @example
         * mStateManager.ChangeSettings(2, null);
         */
        this.ChangeSettings = function (aIndex, aNewValue) {
            var lHash = mCurrentHash.Tab;
            var i = 0;
            for (i = 0; i < mCurrentHash.Settings.length; i++) {
                if (i === aIndex) {
                    lHash = lHash + "." + aNewValue;
                } else {
                    lHash = lHash + "." + mCurrentHash.Settings[i];
                }
            }
            this.ChangeHash(lHash);
        };
        /**
         * Get System State 
         * @example
         * mStateManager.getSystemState();
         * {Tab: "Dashboard"}
         */
        this.getSystemState = function () {
            var lState = {},
                lHash = GetSecondaryHash();
            lState.Tab = GetPrimaryHash();
            lState.Layout = lHash[0];
            lState.Primary = lHash[1];
            lState.Secondary = lHash[2];
            lState.Tertiary = lHash[3];
            return $.extend({}, lState);
        };
        this.getPreviousState = function () {
            var lState = {};
            if(isNullOrUndefined(mPreviousHash.Tab)){
                lHash = GetCurrentHash().Settings;
                lState.Tab = GetPrimaryHash();
            }else {
                lHash = mPreviousHash.Settings; 
                lState.Tab = mPreviousHash.Tab;
            }
            lState.Layout = lHash[0]?lHash[0]:'';
            lState.Primary = lHash[1]?lHash[1]:'';
            lState.Secondary = lHash[2]?lHash[2]:'';
            lState.Tertiary = lHash[3]?lHash[3]:'';
            return $.extend({}, lState);
        };
        this.IsSystemState = function(aState,aName){
            var state = this.getSystemState();
            return state[aState] == aName;
        }
        function Hash_OnChange() {
            mPreviousHash = mCurrentHash;
            mCurrentHash = GetCurrentHash();
            var lInitFunctionName = '',
                lDisposeFuctionName = '',
                lPreference = new UserPreference();
            if (mPreviousHash.Tab !== mCurrentHash.Tab) {
                lDisposeFuctionName = mThis.Id + mPreviousHash.Tab + '_Leave';
                lInitFunctionName = mThis.Id + mCurrentHash.Tab + '_Init';
            } else if (mPreviousHash.Settings[0] !== mCurrentHash.Settings[0]) {
                lDisposeFuctionName = mThis.Id + mPreviousHash.Tab + 'Layout_Leave';
                lInitFunctionName = mThis.Id + mCurrentHash.Tab + 'Layout_Init';
            } else if (mPreviousHash.Settings[1] !== mCurrentHash.Settings[1]) {
                lDisposeFuctionName = mThis.Id + mPreviousHash.Tab + 'Primary_Leave';
                lInitFunctionName = mThis.Id + mCurrentHash.Tab + 'Primary_Init';
            } else if (mPreviousHash.Settings[2] !== mCurrentHash.Settings[2]) {
                lDisposeFuctionName = mThis.Id + mPreviousHash.Tab + 'Secondary_Leave';
                lInitFunctionName = mThis.Id + mCurrentHash.Tab + 'Secondary_Init';
            } else if (mPreviousHash.Settings[3] !== mCurrentHash.Settings[3]) {
                lDisposeFuctionName = mThis.Id + mPreviousHash.Tab + 'Tertiary_Leave';
                lInitFunctionName = mThis.Id + mCurrentHash.Tab + 'Tertiary_Init';
            }
            if (!isNullOrUndefined(mPreviousHash.Tab) && !isNullOrUndefined(window[lDisposeFuctionName])) {
                window[lDisposeFuctionName](mPreviousHash, mCurrentHash);
            } else {
                //alert(lDisposeFuctionName);
            }
            if (!isNullOrUndefined(window[lInitFunctionName])) {
                window[lInitFunctionName](mPreviousHash, mCurrentHash);
            } else {
                //alert(lInitFunctionName);
            }
            window[mThis.Id + '_Init']();
            lPreference.ColumnName = 'PageState';
            lPreference.Id = gUserDetails.UserId;
            lPreference.UserPreferenceType = 10;
            lPreference.Value = window.location.hash;
           // writeUserPreferences([lPreference]);
        }
        this.GoTo = function(aHash){
            window.location.hash = aHash;
        }
        $(window).hashchange(Hash_OnChange);
    }   
    return SumoStateManager; 
})();
//#endregion

function Sad(aParams, aError, aStatus, aError2, aFunction) {
    "use strict";
    mActivityNotification.addNotification('Web service error (' + aParams + '): ' + aStatus);
    //aFunction();
}
(function(){
    // return Form;
    /**
     * This function will easily set and get values from an HTML table form
     * @param  {string} uBaseElementId will be concatenated with every field name 
     * @param  {string} uGroupSelectorName
     * @param  {array} fields
     * @constructor
     */
    function FieldsCtrl(aBaseElementId,aGroupSelectorName,fields){
        this.elementId = aBaseElementId; // '#uVictimProfile';
        this.elementGroupId = aGroupSelectorName;
        this.fields = fields;
        this.values ={};
    }
    FieldsCtrl.prototype.toggleGroup = function (flag){
        var _id = '#'+this.elementId + this.elementGroupId;
        $(_id).toggle(flag);
    }
    FieldsCtrl.prototype.displayOnly = function (aField,flag){
        var _id = '#'+this.elementId + aField;
        $(_id ).toggle(flag);
        $(_id + 'Edit').toggle(!flag);
    }
    FieldsCtrl.prototype.removeValidations = function(){
        for(var i=0;i<this.fields.length; i++){
            $('#'+this.elementId+this.fields[i].name+'Edit').removeClass('Validate ValidateRange');
        }
    }
    FieldsCtrl.prototype.toggleAll = function (flag){
        for(var i=0;i<this.fields.length; i++){
            // $('#'+this.elementId+this.fields[i].name).toggle(flag);
            $('#'+this.elementId+this.fields[i].name+'Edit').toggle(flag);
        }
        this.toggleGroup(flag);
    }
    
    function getElementTypeById(selectorId){
        var elm = document.getElementById(selectorId);
        if(elm === null){
            return;
        }
        var isValidElement = elm.constructor == (HTMLSelectElement || HTMLInputElement);
        function getHTMLInputElementType(type){
            switch(type){
                case 'checkbox':         
                    return convertBoolToInteger(elm.checked);
                    break;
                default: 
                    return elm.value;
            }
        }
        return getHTMLInputElementType(elm.type);
    }
    function convertTo(aType,aValue){
       
        switch(aType){
            case 'string':
                if(isNullOrUndefined(aValue)){
                    aValue = "";
                }
                return String(aValue);
            case 'number':
                if(isNullOrUndefined(aValue) || aValue === ""){
                    aValue = -1;
                }
                return parseFloat(aValue);
            case 'boolean':
                return Boolean(aValue)
            default:
                return aValue
        }
    }
    FieldsCtrl.prototype.Element = function(aFieldName){
        return document.getElementById(this.elementId+aFieldName+'Edit');
    }
    FieldsCtrl.prototype.getValue = function(aFieldName){
        
        return getElementTypeById(this.elementId+aFieldName+'Edit');//   $('#'+this.elementId+aFieldName+'Edit').val();
    }
    FieldsCtrl.prototype.getValues = function (){
        var res = {}
        for(var i=0;i<this.fields.length; i++){
            res[this.fields[i].name] = convertTo(this.fields[i].type,this.getValue(this.fields[i].name));
        }
        this.values = res;
        return res;
    }
    FieldsCtrl.prototype.setValues = function (values){
        for(var key in values){
            $('#'+this.elementId+key).text(values[key]);
            $('#'+this.elementId+key+'Edit').val(values[key]);
        }
        this.values = Object.assign({},this.values,values);
    }
    FieldsCtrl.prototype.setValue = function (aFieldName,aValue){
        $('#'+this.elementId+aFieldName).text(aValue);
        $('#'+this.elementId+aFieldName+'Edit').val(aValue);
        this.values[aFieldName] = aValue;
    }
    window.FieldsFormController = FieldsCtrl; 
})();
